<template>
  <text-input
    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
    :model="model"
    :type="showPassword ? 'text' : 'password'"
    @click:append="showPassword = !showPassword"
  />
</template>

<script>
import TextInput from '@/components/forms/TextInput';

// @vuese
// Input hasła
// @group forms
export default {
  components: { TextInput },
  props: {
    // @vuese
    // schema hasła
    model: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showPassword: false
    };
  }
};
</script>
